import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { ITicketDrawerRequest } from '../models';

export const NEW_TICKET_QUERY_PARAM = 'ticket';
const NEW_TICKET_QUERY_VALUE = 'new';
const NEW_TICKET_HISTORY_STATE = 'newTicketFromDetail';

export const TICKET_DRAWER_ELEMENT_IDS = ['suggestionsDetailContainer', 'conversationModal', 'publicVisibilityModal'];

export function ticketDrawerElements(): Node[] {
  return TICKET_DRAWER_ELEMENT_IDS.map((elementId) => document.getElementById(elementId)).filter(
    (element): element is HTMLElement => !!element,
  );
}

export function withoutNewTicketQueryParam(queryParams: Params): Params {
  const { [NEW_TICKET_QUERY_PARAM]: _newTicket, ...otherQueryParams } = queryParams;
  return otherQueryParams;
}

function ticketQueryValue(request: ITicketDrawerRequest): string {
  return request.suggestionId ? String(request.suggestionId) : NEW_TICKET_QUERY_VALUE;
}

export class DetailTicketDrawer {
  public request?: ITicketDrawerRequest;
  private pendingRequest?: ITicketDrawerRequest;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  get isNewTicketOpen(): boolean {
    return !!this.request && !this.request.suggestionId;
  }

  open(request: ITicketDrawerRequest) {
    if (this.request && ticketQueryValue(this.request) === ticketQueryValue(request)) return;
    const replaceOpenTicket = !!this.request;
    this.pendingRequest = request;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [NEW_TICKET_QUERY_PARAM]: ticketQueryValue(request) },
      queryParamsHandling: 'merge',
      replaceUrl: replaceOpenTicket,
      state: { [NEW_TICKET_HISTORY_STATE]: replaceOpenTicket ? !!history.state?.[NEW_TICKET_HISTORY_STATE] : true },
    });
  }

  applyQueryParams(params: ParamMap) {
    const requestedTicket = params.get(NEW_TICKET_QUERY_PARAM);
    if (!requestedTicket) {
      this.pendingRequest = undefined;
      this.request = undefined;
      return;
    }
    if (this.request && ticketQueryValue(this.request) === requestedTicket) return;
    if (this.pendingRequest && ticketQueryValue(this.pendingRequest) === requestedTicket) {
      this.request = this.pendingRequest;
      this.pendingRequest = undefined;
      return;
    }
    const requestedSuggestionId = Number(requestedTicket);
    if (requestedSuggestionId > 0) {
      this.request = { suggestionId: requestedSuggestionId };
      return;
    }
    this.request = undefined;
    this.removeTicketFromUrl();
  }

  close() {
    const ticketWasOpen = !!this.request;
    this.request = undefined;
    if (!ticketWasOpen) return;
    if (history.state?.[NEW_TICKET_HISTORY_STATE]) history.back();
    else this.removeTicketFromUrl();
  }

  private removeTicketFromUrl() {
    this.pendingRequest = undefined;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { [NEW_TICKET_QUERY_PARAM]: null },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }
}
